var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_203",
    x: 0,
    y: 0,
    width: 54,
    height: 54,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7ab53f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36953e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2428",
    "data-name": "Group 2428",
    transform: "translate(-108 -558)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 108, 558)",
    filter: "url(#Ellipse_203)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_203-2",
    "data-name": "Ellipse 203",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "envelope",
    transform: "translate(125.019 571.851)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5053",
    "data-name": "Path 5053",
    d: "M19.924,5.542l-7,7a4.165,4.165,0,0,1-5.882,0l-7-7C.027,5.673,0,5.792,0,5.923V15.9a4.164,4.164,0,0,0,4.159,4.159H15.8A4.164,4.164,0,0,0,19.962,15.9V5.923C19.962,5.792,19.935,5.673,19.924,5.542Z",
    transform: "translate(0 -0.764)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5054",
    "data-name": "Path 5054",
    d: "M11.871,10.6l7.6-7.6A4.147,4.147,0,0,0,15.928,1H4.284A4.147,4.147,0,0,0,.744,3.005l7.6,7.6a2.5,2.5,0,0,0,3.53,0Z",
    transform: "translate(-0.125)",
    fill: "url(#linear-gradient)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.eb97590dfa688d107cd21b6996a60435.svg";
export { ForwardRef as ReactComponent };